import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { Observable } from 'rxjs/Rx';
import { Subject } from 'rxjs/Subject';

import { Product } from '../../../_models/product';
import { QueryService } from '../../query.service';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.css']
})
export class SearchInputComponent implements OnInit {
  @Input() placeHolder: string = 'Search products...';
  products: Observable<{} | Product[]>;
  public searching: boolean = false;
  public focusOnList: boolean = true;
  public searchString: string = '';
  @Output() product = new EventEmitter();
  private searchTerms = new Subject<string>();

  constructor(private queryService: QueryService) { }

  search(term: string): void {
    this.searchString = term;
    this.searchTerms.next(term);
  }

  outputProduct(output: Product) {
    this.searching = false;
    this.product.emit(output);
  }

  ngOnInit() {
    this.products = this.searchTerms
      .debounceTime(400)
      .distinctUntilChanged()
      .switchMap(term => term   // switch to new observable each time the term changes
        // return the http search observable
        ? this.queryService.searchProducts(term)
        // or the observable of empty products if there was no search term
        : Observable.of<Product[]>([])
      )
      .catch(error => {
        console.log(error);
        return Observable.of<Product[]>([]);
      });
  }

}




// WEBPACK FOOTER //
// /app/src/app/shared/search-products/search-input/search-input.component.ts